import axios, {AxiosInstance} from 'axios';

class ApiClient {

  private api: AxiosInstance;

  constructor(baseURL?: string) {
    let bURL = (baseURL) ? baseURL : process.env.REACT_APP_API_URL
    this.api = axios.create({
      baseURL: bURL
    });
  }

  public async get(endpoint: string, config: any) {
    try {
      const response = await this.api.get(endpoint, config);
      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  public async put(endpoint: string, data: any, config?: any) {
    try {
      const response = await this.api.put(endpoint, data, config);
      return response;
    } catch (error) {
      console.error('Error putting data:', error);
      throw error;
    }
  }

  public async post(endpoint: string, data: any, config?: any) {
    try {
      const response = await this.api.post(endpoint, data, config);
      return response;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }

  public async patch(endpoint: string, data: any, config?: any) {
    try {
      const response = await this.api.patch(endpoint, data, config);
      return response;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }
}

const apiClient = new ApiClient();
export default apiClient;
